import QuickSearchToolbar from './QuickSearchToolbar';

export default QuickSearchToolbar;
